export default "/images/28d000d034803894f6ea7330e599faa7.avif";